import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDa = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 17 17",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "mask0_9162_14672",
		style: { maskType: "alpha" },
		maskUnits: "userSpaceOnUse",
		x: 0,
		y: 0,
		width: 17,
		height: 17,
		children: /* @__PURE__ */ _jsx("circle", {
			cx: 8.5,
			cy: 8.5,
			r: 8.5,
			fill: "#D9D9D9"
		})
	}), /* @__PURE__ */ _jsxs("g", {
		mask: "url(#mask0_9162_14672)",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M-1 0H24V17H-1V0Z",
			fill: "#C60C30"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M8.25926 0H5.33528V6.95906H-1V9.94152H5.33528V17H8.25926V9.94152H24V6.95906H8.25926V0Z",
			fill: "white"
		})]
	})]
});
export default SvgDa;
